import { useContext } from 'react';

import type { Auth } from '@/entities/auth';
import { AuthContext } from '@/providers/auth';

export function useAuth(): Auth {
  return useContext(AuthContext);
}
